export const NAME = 'practiceExams';
export const LEVEL_ONE = 'PracticeExamsReducer';
